import { Component, ElementRef, NgZone } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppoggioService } from '../_servizi/appoggio.service';
import { CantinaService } from '../_servizi/cantina.service';
import { MessageServiceService } from '../_servizi/message-service.service';
import { v4 as uuidv4 } from 'uuid';
import { StripeService } from '../_servizi/stripe.service';

function TRANSLATE(str: string) {
  return str
}
@Component({
  selector: 'app-collegate',
  templateUrl: './collegate.component.html',
  styleUrls: ['./collegate.component.css']
})
export class CollegateComponent {

  observer!: ResizeObserver;

  checkAbilitato = false;
  abilitato = false;
  nonabilitatoMsg = '';

  codiceForm: any;
  linguaCorrente: string;
  layout: number;
  carrello: boolean;

  tipivisite: any[] = [];
  tipovisiteFiltered: any[] = [];
  regioni: any[] = [];
  filtroRegione = null;

  tipologie = [
    { idTipologia: 'T', label: TRANSLATE('generale.tutte'), visibile: true },
    { idTipologia: 'D', label: TRANSLATE('generale.degustazione'), visibile: false },
    { idTipologia: 'W', label: TRANSLATE('generale.degustazioneweb'), visibile: false },
    { idTipologia: 'R', label: TRANSLATE('generale.ristorazione'), visibile: false },
    { idTipologia: 'C', label: TRANSLATE('generale.picnic'), visibile: false },
    { idTipologia: 'P', label: TRANSLATE('generale.pernottamento'), visibile: false },
  ];
  filtroTipologia = null;

  isVisibleRegioni = false;
  isVisibleTipologie = false;

  loading = false;

  idSezione = null;

  sezione = null;

  constructor(
    private messageService: MessageServiceService,
    private host: ElementRef,
    private zone: NgZone,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private adapter: DateAdapter<any>,
    private cantinaService: CantinaService,
    private appoggioService: AppoggioService,
    private stripeService: StripeService
  ) { }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params) => {

      this.codiceForm = params.get('cantina');
      this.linguaCorrente = params.get('lingua');
      this.layout = parseInt(params.get('layout'));
      this.idSezione = parseInt(params.get('idSezione'));
      this.carrello = params.get('cart') === '1' ? true : false;

      this.translate.use(this.linguaCorrente);
      this.adapter.setLocale(this.translate.currentLang);

      this.controllaCantina(this.codiceForm);

      let idCookie = params.get('idCookie');

      if (idCookie && idCookie !== 'null') {

        this.messageService.setIdCookie(idCookie);
      } else {
        idCookie = uuidv4();
        this.messageService.sendIdCookie(idCookie);
        this.messageService.setIdCookie(idCookie);
      }
    });

    this.observer = new ResizeObserver(entries => {
      this.zone.run(() => {
        this.messageService.sendHeighMessageCollegate(entries[0].contentRect.height);
      });
    });
    this.observer.observe(this.host.nativeElement);

  }
  ngOnDestroy(): void {
    this.observer.unobserve(this.host.nativeElement);
  }

  controllaCantina(codiceForm): void {
    this.loading = true;
    this.cantinaService.getStato(codiceForm)
      .subscribe(cantina => {
        this.checkAbilitato = true;
        if (cantina && cantina.length > 0) {

          this.appoggioService.setCodiceForm(codiceForm);

          this.appoggioService.setColoriIframe(cantina[0]);
          this.stripeService.setInfoStripe(null);

          if (cantina[0]['abilitatocantinemultiple'] === '1') {
            const clientUrl = document.referrer;
            this.abilitato = true;


            this.cantinaService.getTipoVisiteCollegate(codiceForm, this.linguaCorrente, this.idSezione)
              .subscribe(dati => {
                this.tipivisite = dati['tipovisite'];
                this.tipovisiteFiltered = dati['tipovisite'];
                this.sezione = dati['sezione'];

                for (const tipovisita of this.tipivisite) {
                  this.regioni.push({ idRegione: tipovisita.idRegione, regione: tipovisita.regione, traduzione: false });
                  if (tipovisita.tipo.includes('D')) { this.tipologie[1].visibile = true; }
                  if (tipovisita.tipo.includes('W')) { this.tipologie[2].visibile = true; }
                  if (tipovisita.tipo.includes('R')) { this.tipologie[3].visibile = true; }
                  if (tipovisita.tipo.includes('C')) { this.tipologie[4].visibile = true; }
                  if (tipovisita.tipo.includes('P')) { this.tipologie[5].visibile = true; }
                }

                this.regioni = this.regioni.filter((v, i) => this.regioni.findIndex(item => item.idRegione === v.idRegione) === i);
                this.regioni.unshift({ idRegione: '0', regione: TRANSLATE('generale.tutte'), traduzione: true });
                this.filtroRegione = this.regioni[0];


                this.filtroTipologia = this.tipologie[0];
                this.tipologie = this.tipologie.filter(tipologia => tipologia.visibile);

              });
          } else {
            this.abilitato = false;
            this.nonabilitatoMsg = 'nonAbilitato';
          }
        } else {
          this.abilitato = false;
          this.nonabilitatoMsg = 'nonAbilitato';
        }
        setTimeout(() => {
          this.loading = false;
        }, 2000)
      });
  }

  filtra(filtro, filtroValue) {

    switch (filtro) {
      case 1:
        if (this.filtroRegione && this.filtroRegione.idRegione !== filtroValue.idRegione) {
          this.filtroRegione = filtroValue ? filtroValue : this.filtroRegione;
        } else {
          this.filtroRegione = this.regioni[0];
        }
        break;
      case 2:
        if (this.filtroTipologia && this.filtroTipologia.idTipologia !== filtroValue.idTipologia) {
          this.filtroTipologia = filtroValue ? filtroValue : this.filtroTipologia;
        } else {
          this.filtroTipologia = this.tipologie[0];
        }
        break;
    }

    this.tipovisiteFiltered =
      this.tipivisite.filter(
        tipovisita =>
          (tipovisita.idRegione === this.filtroRegione.idRegione || this.filtroRegione.idRegione === '0') &&
          (tipovisita.tipo.includes(this.filtroTipologia.idTipologia) || this.filtroTipologia.idTipologia === 'T')
      )
  }

  resetFiltri() {
    this.filtroRegione = this.regioni[0];
    this.filtroTipologia = this.tipologie[0];
    this.tipovisiteFiltered = this.tipivisite;
  }

  get showFiltro(): boolean {
    return this.cantinaService.getIdxTvSelezionato() != null ? false : true;
  }

  get filtriAreSetted(): boolean {
    return this.filtroRegione.idRegione !== '0' || this.filtroTipologia.idTipologia !== 'T' ? true : false;
  }

  setVisibleFiltro(filtro) {
    switch (filtro) {
      case 1:
        this.isVisibleRegioni = !this.isVisibleRegioni;
        this.isVisibleTipologie = false;
        break;
      case 2:
        this.isVisibleTipologie = !this.isVisibleTipologie;
        this.isVisibleRegioni = false;
        break;
    }
  }

  getVisibleFiltro(filtro) {
    switch (filtro) {
      case 1:
        return this.isVisibleRegioni;
        break;
      case 2:
        return this.isVisibleTipologie;
        break;
    }
  }

  getAttivoFiltro(filtro) {
    switch (filtro) {
      case 1:
        return this.filtroRegione.idRegione !== '0' ? true : false;
        break;
      case 2:
        return this.filtroTipologia.idTipologia !== 'T' ? true : false;
        break;
    }
  }
}